import { IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import { BenefitPricingStructure, IAlacarte } from '../../../redux/slices/PolicyListSlice/types';
import { textPluralize } from '../../../utils/common';
import { IModularSummaryFamilyBenefit } from './types';

export const getModularSummaryAlacarteSubtext = (
    plan: IAlacarte,
    familyBenefit?: IModularSummaryFamilyBenefit
): string => {
    if (plan.pricingStructure === BenefitPricingStructure.PER_LIFE) {
        const count = familyBenefit?.counts.length ?? 0;
        return `${count} ${textPluralize('plan', count)} selected`;
    } else if (plan.subCategories.length) return plan.subCategories[0].name;
    return '';
};

export const getModularSummaryFamilyBenefits = (
    plans: IAlacarte[],
    family: IModularFamily[]
): Record<string, IModularSummaryFamilyBenefit> => {
    const familyDict = family.reduce((acc, member) => ({ ...acc, [member.id]: member }), {});

    return plans
        .filter((plan) => plan.pricingStructure === BenefitPricingStructure.PER_LIFE)
        .reduce((acc, plan) => {
            const subs = plan.subCategories.length ? plan.subCategories : [plan];
            const uniqueFamilyIds = new Set<string>(subs.flatMap((sub) => sub.selectedUserIds ?? []));
            acc[plan.id] = {
                family: Array.from(uniqueFamilyIds)
                    .map((id) => familyDict[id])
                    .filter(Boolean),
                counts: subs.map((sub) => [sub.name, sub.selectedUserIds?.length ?? 0])
            };
            return acc;
        }, {});
};
